/**
 * Mobile sticky add-to-cart bar for the product page.
 *
 * Shows a fixed bottom bar on mobile only while the real add-to-cart button is
 * scrolled out of view. As soon as the original button re-enters the viewport
 * (first fold), the sticky bar hides again. The sticky button proxies its click
 * to the original submit button so the existing AJAX cart logic, variant
 * selection and quantity are all reused untouched.
 */
class MobileStickyAtc extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.scope = document.querySelector('.main-product-' + this.sectionId) || document;
    this.originalBtn = this.scope.querySelector('.main-product_atc-btn');
    this.trigger = this.querySelector('[data-sticky-atc-trigger]');
  }

  connectedCallback() {
    // No buy button on the page (block removed) -> stay hidden, do nothing.
    if (!this.originalBtn || !this.trigger) return;

    this.bindTrigger();
    this.syncButton();
    this.observeVisibility();
    this.observeButtonState();
  }

  bindTrigger() {
    this.trigger.addEventListener('click', () => {
      if (this.originalBtn.disabled) return;
      this.originalBtn.click();
    });
  }

  observeVisibility() {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = !entries[0].isIntersecting;
        this.classList.toggle('is-visible', visible);
        this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      },
      { threshold: 0 }
    );
    observer.observe(this.originalBtn);
  }

  syncButton() {
    this.trigger.disabled = this.originalBtn.disabled;
    const label = this.originalBtn.textContent.trim();
    if (label) this.trigger.textContent = label;
  }

  observeButtonState() {
    const observer = new MutationObserver(() => this.syncButton());
    observer.observe(this.originalBtn, {
      attributes: true,
      attributeFilter: ['disabled'],
      childList: true,
      characterData: true,
      subtree: true,
    });
  }
}

if (!customElements.get('mobile-sticky-atc')) {
  customElements.define('mobile-sticky-atc', MobileStickyAtc);
}
